import { render } from "./BreadCrumbs.vue?vue&type=template&id=79a57964&ts=true"
import script from "./BreadCrumbs.vue?vue&type=script&lang=ts"
export * from "./BreadCrumbs.vue?vue&type=script&lang=ts"

import "./BreadCrumbs.vue?vue&type=style&index=0&id=79a57964&lang=css"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__